module.exports = __webpack_public_path__ + "img/blog13.16f690b8.jpeg";